import { defineStore } from 'pinia';

type DemoOnboardingStateType = {
    isOpen: boolean;
    currentStep: number;
    onComplete: (() => void) | null;
};

export const useDemoOnboardingStore = defineStore('demoOnboarding', {
    state: (): DemoOnboardingStateType => ({
        isOpen: false,
        currentStep: 1,
        onComplete: null,
    }),

    getters: {
        totalModalSteps: (): number => 2,

        stepLabel: (state: DemoOnboardingStateType): string => `${state.currentStep}/4`,
    },

    actions: {
        open(): void {
            this.isOpen = true;
            this.currentStep = 1;
        },

        nextStep(): void {
            if (this.currentStep < this.totalModalSteps) {
                this.currentStep++;
            } else {
                this.complete();
            }
        },

        complete(): void {
            this.isOpen = false;
            this.currentStep = 1;

            if (this.onComplete) {
                this.onComplete();
                this.onComplete = null;
            }
        },
    },
});
